export const storeModal = {
  namespaced: true,

  state: { },

  actions: {
    updateModalState ({ commit }, modal) {
      commit('updateModal', modal)
    }
  },

  mutations: {
    updateModal (state, modal) {
      this.state.modal[modal.id] = modal.isActive
    }
  }
}